import React, { useContext, useState } from "react";

import { useAppStore } from "../../../../../context/store";
import { Dialog, CloseButton, Button, Text, HStack, Field, Input, Select, createListCollection, Portal } from "@chakra-ui/react";
import { filterRoadSlopeOnDataSource } from "../../../../../utilies/geojson/Slope";
import { useMapObjects } from "../../../../../context/MapObjectsContext";

const LayersRoadSlopeDialog = () => {
  // state
  const showRoadSlopeDialog = useAppStore((s) => s.showRoadSlopeDialog);
  const defaultGeojsonStyle = useAppStore((s) => s.defaultGeojsonStyle);
  const basicGeojsonStyle = useAppStore((s) => s.basicGeojsonStyle);
  const defaultOsmStyle = useAppStore((s) => s.defaultOsmStyle);

  // setters / refs
  const setShowRoadSlopeDialog = useAppStore.getState().setShowRoadSlopeDialog;
  const viewerRef = useAppStore.getState().viewerRef;
  const { mapObjects, setMapObjects, mapObjectsRef } = useMapObjects();
  const originalCameraControls = useAppStore.getState().originalCameraControls;

  const operators = createListCollection({
    items: [
      { label: ">=", value: ">=" },
      { label: "<=", value: "<=" },
      { label: ">", value: ">" },
      { label: "<", value: "<" },
    ],
  });

  const [slope, setSlope] = useState(0);
  const [condition, setCondition] = useState(">=");

  const filter = () => {
    const dataSource = showRoadSlopeDialog?.data?.dataSource;
    if (!dataSource) return;

    filterRoadSlopeOnDataSource(dataSource, parseFloat(slope), condition);
  };

  const resetSlopeFilter = () => {
    const dataSource = showRoadSlopeDialog?.data?.dataSource;
    if (!dataSource) return;

    filterRoadSlopeOnDataSource(dataSource, parseFloat(slope), condition, true);
  };

  return (
    <Dialog.Root modal={false} open={showRoadSlopeDialog?.open ? true : false} closeOnInteractOutside={false}>
      <Portal>
        <Dialog.Positioner style={{ pointerEvents: "none" }}>
          <Dialog.Content style={{ pointerEvents: "auto" }}>
            <Dialog.Header>
              <Dialog.Title>Road Slope</Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <HStack gap={3}>
                <Select.Root
                  collection={operators}
                  size="sm"
                  width="320px"
                  defaultValue={[condition]}
                  onValueChange={(v) => {
                    setCondition(v.value[0]);
                  }}
                >
                  <Select.HiddenSelect />
                  <Select.Label>Condition</Select.Label>
                  <Select.Control>
                    <Select.Trigger>
                      <Select.ValueText placeholder="Select condition" />
                    </Select.Trigger>
                    <Select.IndicatorGroup>
                      <Select.Indicator />
                    </Select.IndicatorGroup>
                  </Select.Control>

                  <Select.Positioner>
                    <Select.Content>
                      {operators.items.map((operator) => (
                        <Select.Item item={operator} key={operator.value}>
                          {operator.label}
                          <Select.ItemIndicator />
                        </Select.Item>
                      ))}
                    </Select.Content>
                  </Select.Positioner>
                </Select.Root>
                <Field.Root>
                  <Field.Label>Slope (degree)</Field.Label>
                  <Input
                    placeholder="Enter slope"
                    value={slope}
                    type="number"
                    onChange={(v) => {
                      setSlope(v.target.value);
                    }}
                  />
                </Field.Root>
              </HStack>
            </Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowRoadSlopeDialog(null);
                  }}
                >
                  Cancel
                </Button>
              </Dialog.ActionTrigger>

              <Button
                colorPalette={"red"}
                onClick={() => {
                  resetSlopeFilter();
                }}
              >
                Reset
              </Button>
              <Button
                onClick={() => {
                  filter();
                }}
              >
                Filter
              </Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger
              asChild
              onClick={() => {
                setShowRoadSlopeDialog(null);
              }}
            >
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayersRoadSlopeDialog;
